import SegregationPlantCreate from "../components/views/segregationPlant/segregationPlantCreate.vue";
import Segregation from "../components/views/segregationPlant/segregation.vue";

const routes = [
  {
    path: "segregation",
    component: Segregation,
    name: "segregation",
    meta: {
      description: "List of Segregation Plants",
      title: "Segregation Plant",
      requiresAuth: true,
    },
  },
  {
    path: "segregation/segregationPlantCreate/:_id",
    component: SegregationPlantCreate,
    name: "segregationPlantCreate",
    meta: {
      //   description: "Add a new Segregation",
      title: "Add / Update Segregation Plant",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/segregation.route.js